import {css, html, LitElement} from "@isceco/widget-library2/external/lit";
import {getFomanticStylesheet} from "@isceco/widget-library2/assets/fomantic-icons-styles";

export default class InlineNotification extends LitElement {

  static get properties() {
    return {
      title: {type: String},
      variant: {type: String}
    }
  }

  static get styles() {

    return [css`
      .container {
        font-family: var(--isceco-font);
        padding: var(--isceco-space-300);
        border-radius: 4px;
        position: relative;
        display: flex;
        flex-direction: row;
        gap: var(--isceco-space-200);
      }

      .container.info {
        background-color: var(--isceco-color-blue-100);
        color: var(--isceco-color-blue-500);
      }

      .container.warning {
        background-color: var(--isceco-color-yellow-300);
        color: var(--isceco-color-black);
      }

      .container.danger {
        background-color: var(--isceco-color-red-100);
        color: var(--isceco-color-red-500);
      }

      .container > i {
        flex: 0;
        padding-top: 2px;
      }

      .container > div {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: var(--isceco-space-200);
      }

      .container > div > * {
        margin: 0;
      }

      .container > div > *:empty:not(slot) {
        display: none;
      }

    `]
  }

  constructor(props) {
    super(props);
  }

  connectedCallback() {
    super.connectedCallback();

    getFomanticStylesheet()
      .then(stylesheet => {
        this.shadowRoot.adoptedStyleSheets = [...this.shadowRoot.adoptedStyleSheets, stylesheet]
      })
      .catch(error => {
        throw error
      })
  }

  render() {
    const icon = {
      info: 'icon info circle',
      warning: '',
      danger: 'icon exclamation triangle'
    }[this.variant]
    return html`
      <div class="container ${this.variant}">
        <i class="${icon}"></i>
        <slot></slot>
      </div>
    `
  }
}
customElements.define('inline-notification', InlineNotification)
